import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/api/dashboard';

type DashboardFilter = {
  year: number;
  month: number | null;
};

export const useDashboardStats = (filter: DashboardFilter) => {
  return useQuery({
    queryKey: ['dashboard', 'stats', filter],
    queryFn: () => dashboardApi.getStats(filter),
  });
};

export const useDonaturChart = (filter: DashboardFilter) => {
  return useQuery({
    queryKey: ['dashboard', 'chart', 'donatur', filter],
    queryFn: () => dashboardApi.getDonaturChart(filter),
  });
};

export const useBulletinChart = (filter: DashboardFilter) => {
  return useQuery({
    queryKey: ['dashboard', 'chart', 'bulletin', filter],
    queryFn: () => dashboardApi.getBulletinChart(filter),
  });
};

export const useDonasiChart = (filter: DashboardFilter) => {
  return useQuery({
    queryKey: ['dashboard', 'chart', 'donasi', filter],
    queryFn: () => dashboardApi.getDonasiChart(filter.year, filter),
  });
};

export const useDashboardRecentActivities = (limit = 10, filter?: DashboardFilter) => {
  return useQuery({
    queryKey: ['dashboard', 'recent-activities', limit, filter],
    queryFn: () => dashboardApi.getRecentActivities(limit, filter),
  });
};
